<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">
        <div class="box citic-box">
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <div class="add-btn" style="margin-bottom: 20px;">
              <el-button type="primary" @click="handleEdit()">增加新成员</el-button>
            </div>
          <!-- 搜索 -->
            <div>
              <el-input
              class="search"
              placeholder="按人物姓名搜索"
              type="text"
              v-model.trim="keywords"
              width="10%"
              >
              </el-input>
              <el-button
                @click="onSearch"
                class="btn-search"
                type="primary"
              >搜索</el-button>
              <el-button
                @click="onDelete"
                class="btn-search"
                type="danger"
              >删除</el-button>
            </div>
            <el-tab-pane label="人物列表" name="person">
             <!-- 文档列表 -->
              <person
                  :tableType="tableType"
                  :tableData = "topuserList"
                  :tableLabel = "tableLabel"
                  :tableImg = "tableImg"
                  @edit="handleEdit"
                  @delete="handleDelete"
                  @upSort="upSort"
                  @downSort="downSort"
              ></person>
              <div class="tip" v-if="topuserList.length">
                <div class="load-more-btn" style="text-align: center;" @click="loadMore" v-if="currentPage === totalPage">没有更多数据~~</div>
                <div class="load-more-btn" style="text-align: center;font-size: 18px;cursor: pointer" @click="loadMore" v-else>点击加载更多</div>
              </div>
              <!-- 分页 -->
<!--              <Pagination-->
<!--                @current-change="handlePageChange"-->
<!--                :current-page="currentPage"-->
<!--                :page-size="pageSize"-->
<!--                :total="total">-->
<!--              </Pagination>-->
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import person from '../../widgets/widghtNews'
import Pagination from '../../widgets/widghtPagination'

export default {
  name: 'PostHome',
  components: {
    person,
    Pagination
  },
  data () {
    return {
      tableImg: [
        {
          prop: 'head_images',
          label: '头像'
        }
      ],
      tableLabel: [
        {
          prop: 'USERNAME',
          label: '姓名'
        },
        {
          prop: 'COMPANY',
          label: '公司'
        },
        {
          prop: 'POSITION',
          label: '职位'
        },
        {
          prop: 'CREATETIME',
          label: '增加时间'
        }
      ],
      placeholder: '按人物姓名搜索',
      topuserList: [],
      activeName: 'person',
      currentPage: 1,
      total: 0,
      totalPage: 0,
      pageSize: 10,
      loading: false,
      keywords: '',
      tableType: 'person'
    }
  },
  methods: {
    // 编辑
    handleEdit (id) {
      console.log(id)
      /*
      * 两种情况：
      * 1、增加成员(没有Id)
      * 2、编辑成员(有Id)
      * */
      if (id) {
        this.$router.push(`/person/edit/${id}`)
      } else {
        this.$router.push(`/person/add`)
      }
    },
    handleClick () {
      console.log(this.activeName)
    },
    // 搜索回车/虚拟操作键盘搜索
    onSearch () {
      console.log(this.keywords)
      this.fetchData()
    },
    // 删除搜索内容
    onDelete () {
      this.keywords = ''
      this.fetchData()
    },
    // 获取100人列表数据
    fetchData () {
      let url = this.$config.API.topuser.list
      let params = {
        keys: this.keywords,
        page: Number(this.currentPage)
      }
      axios.post(url, params).then(res => {
        console.log(res)
        if (res.status === 200 && res.data.result === 'success') {
          this.topuserList = res.data.topuserList
          this.total = res.data.total
          this.totalPage = res.data.total_page
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 加载更多
    loadMore () {
      if (this.currentPage >= this.totalPage) return
      this.currentPage += 1
      let url = this.$config.API.topuser.list
      axios.post(url, {
        keys: this.keywords,
        page: Number(this.currentPage)
      }).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          this.topuserList = this.topuserList.concat(res.data.topuserList)
          this.total = res.data.total
          this.totalPage = res.data.total_page
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 删除人物
    handleDelete (userId) {
      let url = this.$config.API.topuser.delete
      let params = {
        topuser_id: userId
      }
      this.$confirm('要删除该人物吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.post(url, params).then(res => {
          if (res.status === 200 && res.data.result === 'success') {
            this.topuserList = this.topuserList.filter(item => {
              return item.ID !== userId
            })
            this.$message({
              type: 'info',
              message: '已删除'
            })
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 页面分页
    handlePageChange (page) {
      this.currentPage = page
      this.fetchData()
    },
    // 向上排序
    upSort (userId) {
      // 获取userId在数组中位置
      let index = this.topuserList.findIndex(item => {
        return item.ID === userId
      })
      // 获取到上一个人物的ID
      let prevUserId = this.topuserList[index - 1].ID
      let params = {
        up_topuser_id: prevUserId,
        down_topuser_id: userId
      }
      let url = this.$config.API.topuser.sort
      axios.get(url, {params}).then(res => {
        console.log(res)
        if (res.status === 200 && res.data.result === 'success') {
          // 上移
          this.topuserList.splice(index - 1, 1, ...this.topuserList.splice(index, 1, this.topuserList[index - 1]))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 向下排序
    downSort (userId) {
      // 获取userId在数组中位置
      let index = this.topuserList.findIndex(item => {
        return item.ID === userId
      })
      // 获取到下一个人物的ID
      let nextUserId = this.topuserList[index + 1].ID
      let params = {
        up_topuser_id: userId,
        down_topuser_id: nextUserId
      }
      let url = this.$config.API.topuser.sort
      axios.get(url, {params}).then(res => {
        if (res.status === 200 && res.data.result === 'success') {
          // 下移
          this.topuserList.splice(index, 1, ...this.topuserList.splice(index + 1, 1, this.topuserList[index]))
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  mounted () {
    this.fetchData()
  }
}
</script>
<style lang="scss">
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
  .search {
    width: 80%;
    margin-bottom: 20px;
  }
  .btn-search {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// person.vue?0d28ea2c